import { render, staticRenderFns } from "./Tele2DadataAddressSelect.vue?vue&type=template&id=b5a30ffc&scoped=true&"
import script from "./Tele2DadataAddressSelect.vue?vue&type=script&lang=js&"
export * from "./Tele2DadataAddressSelect.vue?vue&type=script&lang=js&"
import style0 from "./Tele2DadataAddressSelect.vue?vue&type=style&index=0&id=b5a30ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a30ffc",
  null
  
)

export default component.exports